export const DocumentLibrary = {
    folderId: "17332cb3-1e41-4aac-a6a0-1ee794429211",
};